/**
 * @author       matt@zumper.com (Matthieu Devlin)
 * @copyright    Copyright (c) 2024, Zumper
 */

const firstPathMatch = (
  pathname: string,
  regexs: Array<RegExp>
): RegExpExecArray | undefined => {
  for (const regex of regexs) {
    const match = regex.exec(pathname)
    if (match) {
      return match
    }
  }
  return undefined
}

export const getLegacyReactRouterParams = (
  pathname: string,
  regexs: Array<RegExp>
): { [p: string]: string } => {
  const match = firstPathMatch(pathname, regexs)
  if (!match || !match.groups) {
    return {}
  }
  return match.groups
}
